/*
 * KAYA — Product reviews (Task 17).
 * Modal control, CSB outline→ink star selector (mouse + keyboard a11y),
 * glaze media-tile previews (client-side only), client-side search/sort/rating/
 * with-media filtering, submit validation, and post-contact thank-you handling.
 * Submission itself is a native Shopify {% form 'contact' %} POST (full reload).
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__kayaRvInit) return;
    root.__kayaRvInit = true;

    var modal = root.querySelector('[data-kaya-rv-modal]');
    var openers = root.querySelectorAll('[data-kaya-rv-open]');
    var lastFocus = null;

    /* ---------- Modal open / close ---------- */
    function openModal() {
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var focusable = modal.querySelector(
        'button:not([data-kaya-rv-close]), [href], input, textarea, select, [tabindex]'
      );
      if (focusable) { try { focusable.focus(); } catch (e) {} }
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    openers.forEach(function (btn) { btn.addEventListener('click', openModal); });
    if (modal) {
      modal.querySelectorAll('[data-kaya-rv-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    /* ---------- CSB star selector (outline → ink fill) ---------- */
    var selectWrap = root.querySelector('[data-kaya-rv-select]');
    var ratingInput = root.querySelector('[data-kaya-rv-rating-input]');
    var ratingHint = root.querySelector('[data-kaya-rv-rating-hint]');
    var selected = 0;

    function paint(n) {
      if (!selectWrap) return;
      selectWrap.querySelectorAll('.kaya-rv-select-stars__star').forEach(function (star, i) {
        star.classList.toggle('is-on', i < n);
      });
    }
    function commit(n) {
      selected = n;
      if (ratingInput) ratingInput.value = n ? String(n) : '';
      if (selectWrap) {
        selectWrap.querySelectorAll('.kaya-rv-select-stars__star').forEach(function (star, i) {
          var on = (i + 1) === n;
          star.setAttribute('aria-checked', on ? 'true' : 'false');
          star.tabIndex = on || (n === 0 && i === 0) ? 0 : -1;
        });
      }
      if (n && ratingHint) ratingHint.hidden = true;
      paint(n);
    }
    if (selectWrap) {
      var stars = Array.prototype.slice.call(
        selectWrap.querySelectorAll('.kaya-rv-select-stars__star')
      );
      stars.forEach(function (star, idx) {
        star.addEventListener('mouseenter', function () { paint(idx + 1); });
        star.addEventListener('click', function () { commit(idx + 1); });
        star.addEventListener('keydown', function (e) {
          var n = selected;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); commit(Math.min(5, (selected || 0) + 1)); stars[selected - 1].focus(); }
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); commit(Math.max(1, (selected || 1) - 1)); stars[selected - 1].focus(); }
          else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); commit(idx + 1); }
        });
      });
      selectWrap.addEventListener('mouseleave', function () { paint(selected); });
      commit(0);
    }

    /* ---------- glaze Media tile (client-side preview only) ---------- */
    var mediaInput = root.querySelector('[data-kaya-rv-media-input]');
    var mediaPreviews = root.querySelector('[data-kaya-rv-media-previews]');
    var mediaFlag = root.querySelector('[data-kaya-rv-media-flag]');
    var mediaTile = root.querySelector('.kaya-rv-modal__media-tile');
    if (mediaTile && mediaInput) {
      mediaTile.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); mediaInput.click(); }
      });
    }
    if (mediaInput && mediaPreviews) {
      mediaInput.addEventListener('change', function () {
        mediaPreviews.innerHTML = '';
        var files = Array.prototype.slice.call(mediaInput.files || []).slice(0, 6);
        files.forEach(function (file) {
          if (file.type && file.type.indexOf('image') === 0) {
            var img = document.createElement('img');
            img.className = 'kaya-rv-modal__media-thumb';
            img.alt = file.name;
            img.src = URL.createObjectURL(file);
            mediaPreviews.appendChild(img);
          } else {
            var ph = document.createElement('span');
            ph.className = 'kaya-rv-modal__media-thumb';
            ph.style.cssText = 'display:flex;align-items:center;justify-content:center;font-size:10px;text-align:center;padding:4px;color:#666;';
            ph.textContent = file.name.length > 18 ? file.name.slice(0, 16) + '…' : file.name;
            mediaPreviews.appendChild(ph);
          }
        });
        if (mediaFlag) mediaFlag.value = files.length ? 'Yes' : 'No';
      });
    }

    /* ---------- Submit validation (rating required) ---------- */
    var form = document.getElementById('kaya-review-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (ratingInput && !ratingInput.value) {
          e.preventDefault();
          if (ratingHint) ratingHint.hidden = false;
          if (selectWrap) {
            var first = selectWrap.querySelector('.kaya-rv-select-stars__star');
            if (first) first.focus();
            selectWrap.scrollIntoView({ block: 'center' });
          }
        }
      });
    }

    /* ---------- Client-side filters / sort / search ---------- */
    var list = root.querySelector('[data-kaya-rv-list]');
    var searchEl = root.querySelector('[data-kaya-rv-search]');
    var sortEl = root.querySelector('[data-kaya-rv-sort]');
    var ratingEl = root.querySelector('[data-kaya-rv-rating]');
    var mediaBtn = root.querySelector('[data-kaya-rv-media]');
    var noMatch = root.querySelector('[data-kaya-rv-nomatch]');

    if (list) {
      var cards = Array.prototype.slice.call(list.querySelectorAll('.kaya-rv__card'));
      cards.forEach(function (card) {
        var t = (card.querySelector('.kaya-rv__card-title') || {}).textContent || '';
        var b = (card.querySelector('.kaya-rv__card-body') || {}).textContent || '';
        var a = (card.querySelector('.kaya-rv__card-author') || {}).textContent || '';
        card.__text = (t + ' ' + b + ' ' + a).toLowerCase();
        card.__rating = parseInt(card.getAttribute('data-rating'), 10) || 0;
        card.__date = parseInt(card.getAttribute('data-date'), 10) || 0;
        card.__index = parseInt(card.getAttribute('data-index'), 10) || 0;
        card.__media = card.getAttribute('data-has-media') === '1';
      });

      function apply() {
        var q = (searchEl && searchEl.value || '').trim().toLowerCase();
        var rf = (ratingEl && ratingEl.value) || 'all';
        var mediaOnly = mediaBtn && mediaBtn.getAttribute('aria-pressed') === 'true';
        var sort = (sortEl && sortEl.value) || 'relevant';

        var shown = cards.filter(function (card) {
          if (q && card.__text.indexOf(q) === -1) return false;
          if (rf !== 'all' && card.__rating !== parseInt(rf, 10)) return false;
          if (mediaOnly && !card.__media) return false;
          return true;
        });

        shown.sort(function (x, y) {
          if (sort === 'recent') return y.__date - x.__date;
          if (sort === 'highest') return y.__rating - x.__rating || y.__date - x.__date;
          if (sort === 'lowest') return x.__rating - y.__rating || y.__date - x.__date;
          return (y.__media - x.__media) || (y.__rating - x.__rating) || (y.__date - x.__date);
        });

        cards.forEach(function (card) { card.style.display = 'none'; });
        shown.forEach(function (card) { card.style.display = ''; list.appendChild(card); });
        if (noMatch) {
          noMatch.hidden = shown.length !== 0;
          list.appendChild(noMatch);
        }
      }

      if (searchEl) searchEl.addEventListener('input', apply);
      if (sortEl) sortEl.addEventListener('change', apply);
      if (ratingEl) ratingEl.addEventListener('change', apply);
      if (mediaBtn) mediaBtn.addEventListener('click', function () {
        var on = mediaBtn.getAttribute('aria-pressed') === 'true';
        mediaBtn.setAttribute('aria-pressed', on ? 'false' : 'true');
        apply();
      });
      apply();
    }

    /* ---------- Post-submit: open the thank-you, clean the URL ---------- */
    try {
      if (/[?&]contact_posted=true/.test(location.search)) {
        openModal();
        if (window.history && history.replaceState) {
          history.replaceState({}, document.title, location.pathname);
        }
      }
    } catch (e) {}
  }

  function boot() {
    document.querySelectorAll('[data-kaya-reviews]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
